import EditProfilePRPForm from './EditProfilePRPFormContainer';

export default EditProfilePRPForm;
